import { useState, useEffect, useMemo } from "react";
import Favicon from "../../../components/favicon/Favicon";
import AfterUserLogin from "./userlogin/AfterUserLogin";
import { useNavigate } from "react-router-dom";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
} from "../../../helpers/global_helper";
import UserLogin from "./userlogin/UserLogin";
import { useSelector } from "react-redux";
import Popup from "../../../components/popup/Popup";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import HomeScreenPopup from "../../../components/popup/popup-components/HomeScreenPopup";
import { FiMenu } from "react-icons/fi";

const VerticalHeader = (props) => {
  const { componentSetting } = useSelector((state) => ({
    componentSetting: state.componentSettingListR.data,
  }));

  const loggedIn = Boolean(window.localStorage.getItem("user_token"));
  const [popup, setPopup] = useState(false);
  const [popupUnreadMessage, setPopupUnreadMessage] = useState(null);
  const [popupNotificationClosed, setPopupNotificationClosed] = useState(false);
  const [popupMessageId, setPopupMessageId] = useState(null);
  const navigate = useNavigate();
  const urlData = window.location.pathname.split("/").pop();

  useEffect(() => {
    if (!urlData) {
      setPopup(true);
    }
  }, [urlData]);

  useEffect(() => {
    if (loggedIn) {
      const fetchUnreadMessages = () => {
        makeAjax(url.MEMO_API.getUnreadPopUpMessage, [], url.MEMO_MS_EXT)
          .then((response) => {
            if (response.status === respStatus["SUCCESS"]) {
              const messages = response.data || [];
              setPopupUnreadMessage(messages);
              if (messages.length > 0) {
                setPopupMessageId(messages[0]._id);
                setPopupNotificationClosed(true);
              }
            } else {
              showMessage(response);
            }
          });
      };

      fetchUnreadMessages();
      const interval = setInterval(fetchUnreadMessages, 6000);
      return () => clearInterval(interval);
    }
  }, [loggedIn]);

  const handleNotificationPopup = () => {
    if (popupMessageId) {
      makeAjax(url.MEMO_API.updatePopupMessageStatus, { _id: popupMessageId }, url.MEMO_MS_EXT)
        .then((response) => {
          if (response.status === respStatus["SUCCESS"]) {
            navigate("/memo");
          } else {
            showMessage(response);
          }
        });
    }
    setPopupNotificationClosed(false);
  };

  const sideMenuClick = () => {
    props.sideMenuClickProp();
  };

  const renderUserComponent = () => {
    if (!componentSetting || typeof componentSetting?.["device-login-info"]?.["options"]?.["user-login"] === "undefined") {
      return null;
    }
    return loggedIn ? <AfterUserLogin /> : <UserLogin />;
  };

  return (
    <div className="header-components">
      <div className="menu-trig-ver" onClick={sideMenuClick}>
        <FiMenu />
      </div>
      {renderUserComponent()}
      <Favicon />
      {loggedIn && popupUnreadMessage && popupNotificationClosed && (
        <HomeScreenPopup
          handlePopup={handleNotificationPopup}
          popupNotificationClosed={popupNotificationClosed}
          data={popupUnreadMessage}
        />
      )}
      {popup && (
        <Popup handlePoup={() => setPopup(false)} afterLogin={loggedIn} />
      )}
    </div>
  );
};

VerticalHeader.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(VerticalHeader);
